import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export const Footer = () => {
  const { t, getLocalizedUrl } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-white/[0.08] bg-[#030303] py-12 relative overflow-hidden">
      {/* Subtle background effect */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-indigo-500/[0.05] rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-rose-500/[0.05] rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <Link to={getLocalizedUrl("/")} className="flex items-center gap-2 font-bold text-xl hover-scale group">
              <Sparkles className="h-6 w-6 text-indigo-400 group-hover:animate-spin" />
              <span className="text-white">FlashySites</span>
            </Link>
            <p className="text-sm text-white/40">
              {t("footer.description")}
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">{t("footer.product")}</h4>
            <ul className="space-y-2">
              <li>
                <Link to={getLocalizedUrl("/pricing")} className="text-sm text-white/40 hover:text-white transition-smooth relative group inline-block">
                  {t("nav.pricing")}
                  <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-indigo-400 transition-all group-hover:w-full" />
                </Link>
              </li>
              <li>
                <Link to={getLocalizedUrl("/how-it-works")} className="text-sm text-white/40 hover:text-white transition-smooth relative group inline-block">
                  {t("nav.howItWorks")}
                  <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-indigo-400 transition-all group-hover:w-full" />
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">{t("footer.account")}</h4>
            <ul className="space-y-2">
              <li>
                <Link to={getLocalizedUrl("/login")} className="text-sm text-white/40 hover:text-white transition-smooth relative group inline-block">
                  {t("nav.login")}
                  <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-indigo-400 transition-all group-hover:w-full" />
                </Link>
              </li>
              <li>
                <Link to={getLocalizedUrl("/register")} className="text-sm text-white/40 hover:text-white transition-smooth relative group inline-block">
                  {t("nav.register")}
                  <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-indigo-400 transition-all group-hover:w-full" />
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">{t("footer.legal")}</h4>
            <ul className="space-y-2">
              <li>
                <Link to={getLocalizedUrl("/terms")} className="text-sm text-white/40 hover:text-white transition-smooth relative group inline-block">
                  {t("footer.terms")}
                  <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-indigo-400 transition-all group-hover:w-full" />
                </Link>
              </li>
              <li>
                <Link to={getLocalizedUrl("/privacy")} className="text-sm text-white/40 hover:text-white transition-smooth relative group inline-block">
                  {t("footer.privacy")}
                  <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-indigo-400 transition-all group-hover:w-full" />
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-white/[0.08] text-center text-sm text-white/40">
          {t("footer.copyright", { year: currentYear })}
        </div>
      </div>
    </footer>
  );
};
